import React, { useCallback, useEffect, useState } from "react";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";
import * as jose from "jose";

const signingKey = import.meta.env.VITE_SIGNING_KEY;
const urlTokenDuration = import.meta.env.VITE_URL_TOKEN_DURATION || "2m";

export const ChanelEntryPage = () => {
  const [isValidating, setIsValidating] = useState(true);

  // JWT形式のトークンを生成
  const generateAccessToken = useCallback(async () => {
    const encodedSecret = new TextEncoder().encode(signingKey);
    return await new jose.SignJWT({ access_granted: true })
      .setProtectedHeader({ alg: "HS256" })
      .setExpirationTime(urlTokenDuration)
      .setIssuedAt()
      .sign(encodedSecret);
  }, []);

  // URLのトークンを検証
  const validateUrlToken = useCallback(async (token: string): Promise<boolean> => {
    try {
      const encodedSecret = new TextEncoder().encode(signingKey);
      const { payload } = await jose.jwtVerify(token, encodedSecret, {
        algorithms: ["HS256"],
      });
      return payload.access_granted === true;
    } catch {
      return false;
    }
  }, []);

  // 既存のクエリパラメーターを保持してtopページに遷移
  const navigateToTop = useCallback(async () => {
    const accessToken = await generateAccessToken();
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.delete("access_token"); // 古いトークンを削除
    currentParams.set("access_token", accessToken);
    window.location.href = `/top?${currentParams.toString()}`;
  }, [generateAccessToken]);

  // invalidページに遷移
  const navigateToInvalid = useCallback(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.delete("access_token");
    const query = currentParams.toString();
    window.location.href = query ? `/invalid?${query}` : "/invalid";
  }, []);

  // レンダリング時にトークン検証を実行
  useEffect(() => {
    const validateAndNavigate = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("access_token");

      // トークンがない場合は無効
      if (!token) {
        navigateToInvalid();
        return;
      }

      // トークンを検証
      const isValid = await validateUrlToken(token);

      if (isValid) {
        // 有効な場合は新しいトークンを発行してtopへ
        await navigateToTop();
      } else {
        // 無効な場合はinvalidへ
        navigateToInvalid();
      }

      setIsValidating(false);
    };

    validateAndNavigate();
  }, [validateUrlToken, navigateToTop, navigateToInvalid]);

  if (isValidating) {
    return (
      <AnimatedPageTransition>
        <div className="bg-white" style={{ height: window.innerHeight }}>
          {/* 検証中は真っ白な画面 */}
        </div>
      </AnimatedPageTransition>
    );
  }

  return null;
};
